import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { About } from '../components/About';
import { Programs } from '../components/Programs';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Subjects } from '../components/Subjects';

import { Feedbacks } from '../components/Feedbacks';
import { FAQ } from '../components/FAQ';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Navbar />
      <Hero />
      <Stats />
      <About />
      <Programs />
      <WhyChooseUs />
      <Subjects />

      <Feedbacks />
      <FAQ />
      <Contact />
      <Footer />
    </div>
  );
}
